import React from 'react';

const UnderConstruction: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
      <div className="text-center max-w-2xl px-8">
        <img 
          src="https://sonicmakers-uploads.lon1.digitaloceanspaces.com/public/logos/noBgWhite.png" 
          alt="SONIC MAKERS" 
          className="max-w-xs w-full h-auto mx-auto mb-12 drop-shadow-2xl"
        />
        {/* <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          SONIC MAKERS
        </h1> */}
        <p className="text-xl md:text-2xl text-slate-300 mb-8 font-light">
          Our website is currently under construction
        </p>
        <p className="text-lg text-slate-400 italic">
          Coming soon...
        </p>
      </div>
    </div>
  );
};

export default UnderConstruction;